<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Phường/Xã" :options="category_PHUONGXA"
                                :initialValue="modelSearch.phuongXaId" :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { modelSearch.phuongXaId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Kỳ" :options="category_sKY" :initialValue="modelSearch.idKy"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { modelSearch.idKy = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false"
                                @onChange="(e) => { modelSearch.enabled = e; handlePageChange(1) }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="currentSearchType == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="currentSearchType == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <TheSwapButton v-model="currentSearchType" @button-clicked="handlePageChange(1)" />
                        <button type="button" class="btn btn-tool" data-toggle="dropdown" :title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.RESTORE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.RESTORE] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.DELETE_TEMP" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE_TEMP] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.DELETE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE] :isDivider="true">
                                    </TheButtonInDropdown>

                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.ON_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.ON_ENABLED] :isDivider="false">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.OFF_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.OFF_ENABLED] :isDivider="true">
                                    </TheButtonInDropdown>
                                </div>
                            </div>
                        </button>
                        <TheCreateButton :onClickParent="() => { detail(null, 'create') }" />
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th style="width:5%">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                    @click="selectAllRows($event)">
                                                <label for="checkboxAll" class="custom-control-label"></label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="cursor col" style="width:5%" @click="handleSortChange('vanhoaGiadinhVanhoaId')" title="Sắp xếp theo ID">
                                        ID
                                        <span v-if="sortBy == 'vanhoaGiadinhVanhoaId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-2 cursor" style="min-width: 100px;" @click="handleSortChange('tenPhuongXa')" title="Sắp xếp theo tên phường xã">
                                        Tên phường xã
                                        <span v-if="sortBy == 'tenPhuongXa'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" @click="handleSortChange('tenKy')" title="Sắp xếp theo kỳ">
                                        Kỳ
                                        <span v-if="sortBy == 'tenKy'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1">
                                        Tỷ lệ đăng ký
                                    </th>
                                    <th class="col-1">
                                        Tỷ lệ đạt GĐVH
                                    </th>
                                    <th class="col-1">
                                        Tỷ lệ không đạt GĐVH
                                    </th>
                                    <th class="col-1">
                                        Tổng số hộ 3 năm
                                    </th>  
                                    <th class="col-1">
                                        Tỷ lể đạt 3 năm
                                    </th> 
                                    <th class="col-1">
                                        Tỷ lệ được khen thưởng 3 năm
                                    </th> 
                                    <th class="col-1">Hiển thị trên cổng</th>
                                    <th class="col-1 sticky-action">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td @click="selectRow(item.vanhoaGiadinhVanhoaId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span v-if="(csList_Navigate.csList.includes(item.vanhoaGiadinhVanhoaId))" class="text-primary">&check;</span>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                    </td>
                                    <td>{{ item.vanhoaGiadinhVanhoaId }}</td>
                                    <td>{{ item.tenPhuongXa }}</td>
                                    <td>{{ item.tenKy }}</td>
                                    <td>{{ item.tyLeDk }}</td>
                                    <td>{{ item.tyLeDatGdvh }}</td>
                                    <td>{{ item.tyLeKhongdatGdvh }}</td>
                                    <td>{{ item.tsHo3nam }}</td>
                                    <td>{{ item.tyleHoDat3nam }}</td>
                                    <td>{{ item.tyleDuocKhenthuong3nam }}</td>
                                    <td>
                                        <TheSwitchInTable 
                                        :placeholder="'Thay đổi hiển thị trên cổng '"
                                        v-model:initialValue="item.enabled" 
                                        :isReadOnly="currentSearchType == typeDataList.DELETED_LIST.id"
                                        :onChange="(e) => { navigateEnabledChange(item.vanhoaGiadinhVanhoaId, e.target.checked) }"
                                        ></TheSwitchInTable>
                                    </td>
                                    <td class="sticky-action">
                                        <TheButtonInTable
                                            v-model="tableButton.VIEWDETAIL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DETAIL]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.EDIT" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.UPDATE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.DELETE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE_TEMP]">
                                        </TheButtonInTable>
                                        
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.DELETE_REAL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.RESTORE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.RESTORE]">
                                        </TheButtonInTable>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <TheCRUDFrameModal ref="modalCRUDRef" idModal="crudModal" dialogClass="modal-80vw" :headerTitle="title"
        :displaySubmit="loadingSubmit" :onSubmit="handleSubmit" :titleSubmit="title" :styleButton="styleButton"
        v-model:showModalFlag="isShowModal.CRUDModal">
        <div class="row">
            <div class="col-md-12">
                <TheSelect title="Phường xã" :options="category_PHUONGXA"
                    :initialValue="model.phuongXaId" :error="errors.phuongXaId" :isMultiple="false"
                    :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                    @onChange="(e) => { model.phuongXaId = e }" :key="tempKey" />
            </div>
            <div class="col-md-12">
                <TheSelect title="Kỳ" :options="category_cKY" :initialValue="model.idKy" :error="errors.idKy"
                    :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                    @onChange="(e) => { model.idKy = e }" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin đạt gia đình
                            văn hóa:</b>
                    </p>
                </div>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
            <div class="col-md-2">
                <TheInputText title="Tổng số hộ" placeholder="Nhập tổng số hộ"
                    :initialValue="model.tsHo" v-model="model.tsHo" :error="errors.tsHo"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số hộ đăng ký" placeholder="Nhập số hộ đăng ký"
                    :initialValue="model.soHoDk" v-model="model.soHoDk" :error="errors.soHoDk"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ đăng ký" placeholder="Nhập tỷ lệ đăng ký"
                    :initialValue="model.tyLeDk" v-model="model.tyLeDk" :error="errors.tyLeDk"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số hộ đăng ký năm sau" placeholder="Nhập số hộ đăng ký năm sau"
                    :initialValue="model.soHoDkNamsau" v-model="model.soHoDkNamsau"
                    :error="errors.soHoDkNamsau" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ hộ đăng ký năm sau"
                    placeholder="Nhập tỷ lệ đăng ký năm sau" :initialValue="model.tyleHoDkNamsau"
                    v-model="model.tyleHoDkNamsau" :error="errors.tyleHoDkNamsau"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
            <div class="col-md-2">
                <TheInputText title="Số GĐ đạt GĐVH" placeholder="Nhập số GĐ đạt GĐVH"
                    :initialValue="model.soHoDatGdvh" v-model="model.soHoDatGdvh"
                    :error="errors.soHoDatGdvh" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ đạt GĐVH" placeholder="Nhập tỷ lệ GĐVH"
                    :initialValue="model.tyLeDatGdvh" v-model="model.tyLeDatGdvh"
                    :error="errors.tyLeDatGdvh" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số GĐ không đạt GĐVH" placeholder="Nhập số GĐ không đạt GĐVH"
                    :initialValue="model.soHoKhongdatGdvh" v-model="model.soHoKhongdatGdvh"
                    :error="errors.soHoKhongdatGdvh" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ không đạt GĐVH" placeholder="Nhập tỷ lệ không đạt GĐVH"
                    :initialValue="model.tyLeKhongdatGdvh" v-model="model.tyLeKhongdatGdvh"
                    :error="errors.tyLeKhongdatGdvh" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin gia đình
                            có trẻ em:</b>
                    </p>
                </div>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
            <div class="col-md-2">
                <TheInputText title="Tổng số gia đình" placeholder="Nhập tổng số GĐ có trẻ em"
                    :initialValue="model.tsHoGdCoTreEm" v-model="model.tsHoGdCoTreEm"
                    :error="errors.tsHoGdCoTreEm" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số GĐ đạt GĐVH" placeholder="Nhập số GĐ có trẻ em đạt GĐVH"
                    :initialValue="model.soHoGdCoTreEmDatGdvh" v-model="model.soHoGdCoTreEmDatGdvh"
                    :error="errors.soHoGdCoTreEmDatGdvh" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ GĐ đạt GĐVH"
                    placeholder="Nhập tỷ lệ GĐ có trẻ em đạt GĐVH"
                    :initialValue="model.tyLeGdCoTreEmDatGdvh" v-model="model.tyLeGdCoTreEmDatGdvh"
                    :error="errors.tyLeGdCoTreEmDatGdvh" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số GĐ không đạt GĐVH"
                    placeholder="Nhập số GĐ có trẻ em không đạt GĐVH"
                    :initialValue="model.soHoGdCoTreEmKhongdatGdvh"
                    v-model="model.soHoGdCoTreEmKhongdatGdvh"
                    :error="errors.soHoGdCoTreEmKhongdatGdvh" :isReadOnly="isReadOnly"
                    :isRequire=false :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ GĐ không đạt GĐVH"
                    placeholder="Nhập tỷ lệ GĐ có trẻ em không đạt GĐVH"
                    :initialValue="model.tyLeGdCoTreEmKhongdatGdvh"
                    v-model="model.tyLeGdCoTreEmKhongdatGdvh"
                    :error="errors.tyLeGdCoTreEmKhongdatGdvh" :isReadOnly="isReadOnly"
                    :isRequire=false :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin gia đình
                            không trẻ em:</b>
                    </p>
                </div>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
            <div class="col-md-2">
                <TheInputText title="Tổng số gia đình" placeholder="Nhập tổng số HGĐ không trẻ em"
                    :initialValue="model.tsHoGdKhongTreEm" v-model="model.tsHoGdKhongTreEm"
                    :error="errors.tsHoGdKhongTreEm" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số GĐ đạt GĐVH" placeholder="Nhập số GĐ không trẻ em đạt GĐVH"
                    :initialValue="model.soHoGdKhongTreEmDatGdvh"
                    v-model="model.soHoGdKhongTreEmDatGdvh" :error="errors.soHoGdKhongTreEmDatGdvh"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ GĐ đạt GĐVH"
                    placeholder="Nhập tỷ lệ GĐ không trẻ em đạt GĐVH"
                    :initialValue="model.tyLeGdKhongTreEmDatGdvh"
                    v-model="model.tyLeGdKhongTreEmDatGdvh" :error="errors.tyLeGdKhongTreEmDatGdvh"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số GĐ không đạt GĐVG"
                    placeholder="Nhập số GĐ không trẻ em đạt GĐVH"
                    :initialValue="model.soHoGdKhongTreEmKhongdatGdvh"
                    v-model="model.soHoGdKhongTreEmKhongdatGdvh"
                    :error="errors.soHoGdKhongTreEmKhongdatGdvh" :isReadOnly="isReadOnly"
                    :isRequire=false :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ GĐ không đạt GĐVH"
                    placeholder="Nhập tỷ lệ GĐ không trẻ em không đạt GĐVH"
                    :initialValue="model.tyLeGdKhongTreEmKhongdatGdvh"
                    v-model="model.tyLeGdKhongTreEmKhongdatGdvh"
                    :error="errors.tyLeGdKhongTreEmKhongdatGdvh" :isReadOnly="isReadOnly"
                    :isRequire=false :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin gia đình 3
                            năm:</b>
                    </p>
                </div>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
            <div class="col-md-2">
                <TheInputText title="Tổng số gia đình 3 năm"
                    placeholder="Nhập tổng số gia đình 3 năm" :initialValue="model.tsHo3nam"
                    v-model="model.tsHo3nam" :error="errors.tsHo3nam" :isReadOnly="isReadOnly"
                    :isRequire=false :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số GĐ đạt 3 năm" placeholder="Nhập số GĐ đạt 3 năm"
                    :initialValue="model.hoDat3nam" v-model="model.hoDat3nam"
                    :error="errors.hoDat3nam" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ GĐ đạt 3 năm " placeholder="Nhập tỷ lệ GĐ đạt 3 năm"
                    :initialValue="model.tyleHoDat3nam" v-model="model.tyleHoDat3nam"
                    :error="errors.tyleHoDat3nam" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Số GĐ được khen thưởng 3 năm"
                    placeholder="Nhập số số hộ được khen thưởng 3 năm"
                    :initialValue="model.soHoDuocKhenThuong3nam"
                    v-model="model.soHoDuocKhenThuong3nam" :error="errors.soHoDuocKhenThuong3nam"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-2">
                <TheInputText title="Tỷ lệ được khen thưởng 3 năm"
                    placeholder="Nhập tỷ lệ được khen thưởng 3 năm"
                    :initialValue="model.tyleDuocKhenthuong3nam"
                    v-model="model.tyleDuocKhenthuong3nam" :error="errors.tyleDuocKhenthuong3nam"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Ghi chú" placeholder="Nhập ghi chú" :initialValue="model.ghiChu"
                    v-model="model.ghiChu" :error="errors.ghiChu" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="true" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheSwitchButton  title="Hiển thị trên cổng" placeholder="Chọn hiển thị trên cổng" :isReadOnly="isReadOnly" :isRequire=false :key="tempKey" :error="''" v-model:initialValue="model.enabled"> </TheSwitchButton>
            </div>
        </div>
    </TheCRUDFrameModal>

    <TheDetailFrameModal ref="modalDetailRef" idModal="detailModal" dialogClass="modal-lg"
        :headerTitle="'Chi tiết'" v-model:showModalFlag="isShowModal.detailModal">
        <div class="row">
            <div class="col-12  col-sm-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">ID:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.vanhoaGiadinhVanhoaId
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Kỳ:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenKy }}&nbsp;</b>
                </p>
                <p class="text-sm">Phường xã:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenPhuongXa
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 order-1 order-md-2">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin đạt gia đình văn hóa:</b>
                    </p>
                </div>
            </div>
            <div class="col-6  col-sm-12 col-md-6 col-lg-6 order-1 order-md-2">
                <p class="text-sm">Tổng số Hộ:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tsHo }}&nbsp;</b>
                </p>
                <p class="text-sm">Số hộ đăng ký:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoDk }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ đăng ký:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeDk }}&nbsp;</b>
                </p>
                <p class="text-sm">Số hộ đăng ký năm sau:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoDkNamsau }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ hộ đăng ký năm sau:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyleHoDkNamsau }}&nbsp;</b>
                </p>
            </div>
            <div class="col-6  col-sm-12 col-md-6 col-lg-6 order-1 order-md-2">
                <p class="text-sm">Số hộ đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoDatGdvh }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeDatGdvh }}&nbsp;</b>
                </p>
                <p class="text-sm">Số hộ không đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoKhongdatGdvh }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ không đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeKhongdatGdvh }}&nbsp;</b>
                </p>
            </div>
            <div class="col-6  col-sm-12 col-md-6 col-lg-6 order-1 order-md-2">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin đạt gia đình
                            có trẻ em:</b>
                    </p>
                </div>
                <p class="text-sm">Số gia đình có trẻ em:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tsHoGdCoTreEm }}&nbsp;</b>
                </p>
                <p class="text-sm">Số gia đình có trẻ em đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoGdCoTreEmDatGdvh
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ gia đình có trẻ em đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeGdCoTreEmDatGdvh
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Số gia đình có trẻ em không đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoGdCoTreEmKhongdatGdvh
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ gia đình có trẻ em không đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeGdCoTreEmKhongdatGdvh
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col-6  col-sm-12 col-md-6 col-lg-6 order-1 order-md-2">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin đạt gia đình
                            không trẻ em:</b>
                    </p>
                </div>
                <p class="text-sm">Số gia đình không có trẻ em:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tsHoGdKhongTreEm }}&nbsp;</b>
                </p>
                <p class="text-sm">Số gia đình không có trẻ em đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoGdKhongTreEmDatGdvh
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ gia đình không có trẻ em đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeGdKhongTreEmDatGdvh
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Số gia đình không trẻ em không đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoGdKhongTreEmKhongdatGdvh
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ gia đình không trẻ em không đạt GĐVH:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeGdKhongTreEmKhongdatGdvh
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col-6  col-sm-12 col-md-6 col-lg-6 order-1 order-md-2">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin đạt gia đình
                            3 năm:</b>
                    </p>
                </div>
                <p class="text-sm">Số gia đình 3 năm:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tsHo3nam }}&nbsp;</b>
                </p>
                <p class="text-sm">Gia đình đạt 3 năm:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.hoDat3nam }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ gia đình đạt 3 năm:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyleHoDat3nam }}&nbsp;</b>
                </p>
                <p class="text-sm">Số gia đình được khen thưởng 3 năm:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soHoDuocKhenThuong3nam
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ gia đình được khen thưởng 3 năm:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyleDuocKhenthuong3nam
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12  col-sm-12 col-md-12 col-lg-12 order-1 order-md-2">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin khác:</b>
                    </p>
                </div>
            </div>
            <div class="col-12  col-sm-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">Ghi chú:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                </p>
            </div>
            <div class="col-6  col-sm-12 col-md-6 col-lg-6 order-1 order-md-2">
                <p class="text-sm">Hiển thị trên cổng:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                        }}&nbsp;</b>
                </p>
            </div>
        </div>
    </TheDetailFrameModal>
    <TheConfirmDialogModal :title="csList_MapModel.title"
        :confirmLabelButton="csList_MapModel.confirmLabelButton" :onClose="csList_MapModel.onClose"
        :onSubmit="csList_MapModel.onSubmit" :modalContent=csList_MapModel.modalContent
        :isReConfirm=csList_MapModel.isReConfirm :reConfirmMes=csList_MapModel.reConfirmMes
        v-model:showModalFlag="isShowModal.confirmDialogModal"></TheConfirmDialogModal>
    <TheCheckboxConfirmDialogModal :title="csListEnabled_MapModel.title"
        :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton"
        :onClose="csListEnabled_MapModel.onClose" :onSubmit="csListEnabled_MapModel.onSubmit"
        :modalContent=csListEnabled_MapModel.modalContent :key="tempKey"
        :submitArgs="csListEnabled_MapModel.submitArgs" v-model="checkEnable_Memo"
        v-model:showModalFlag="isShowModal.checkBoxConfirmModal">
    </TheCheckboxConfirmDialogModal>



</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import objectDefaultValue from '@/config/object.env'
import TheInputText from '@/components/shareComponents/TheInputText.vue'
import tableValue from '@/config/table.env'
import TheSelect from '@/components/shareComponents/TheSelect.vue'

import TheSwapButton from '@/components/shareComponents/table/button/TheSwapButton.vue'
import TheCreateButton from '@/components/shareComponents/table/button/TheCreateButton.vue'
import TheButtonInDropdown from '@/components/shareComponents/table/button/TheButtonInDropdown.vue'
import TheButtonInTable from '@/components/shareComponents/table/button/TheButtonInTable.vue'
import TheSwitchButton from '@/components/shareComponents/TheSwitchButton.vue'
import TheDetailFrameModal from '@/components/shareComponents/modal/TheDetailFrameModal.vue'
import TheCRUDFrameModal from '@/components/shareComponents/modal/TheCRUDFrameModal.vue'
import TheCheckboxConfirmDialogModal from '@/components/shareComponents/modal/TheCheckboxConfirmDialogModal.vue'
import TheConfirmDialogModal from '@/components/shareComponents/modal/TheConfirmDialogModal.vue'


import TheSwitchInTable from '@/components/shareComponents/table/switch/TheSwitchInTable.vue'

import { giaDinhVanHoaVHModel } from '@/models/vanhoa/giaDinhVanHoaVH.model'
import { tableInteractiveModel } from '@/models/general/tableInteractive.model'

export default {
    name: "TheGiaDinhVanHoaVH",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheSwapButton,
        TheCreateButton,
        TheButtonInDropdown,
        TheButtonInTable,
        TheDetailFrameModal,
        TheCRUDFrameModal,
        TheCheckboxConfirmDialogModal,
        TheConfirmDialogModal,
        TheSwitchButton,
        TheSwitchInTable,

    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],
            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: giaDinhVanHoaVHModel.newModel(),
            model: giaDinhVanHoaVHModel.newFEModel(),
            errors: giaDinhVanHoaVHModel.errors(),
            modelSearch: giaDinhVanHoaVHModel.newPagingSearchModel(),

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            cEnable_Item: null,
            checkEnable_Memo: false,

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,
            category_PHUONGXA: [],
            category_cKY: [],
            category_sKY: [],
            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            isShowModal: {
                CRUDModal: false,
                detailModal: false,
                checkBoxConfirmModal: false,
                confirmDialogModal: false,
            },
            loadingSubmit: false,
            tempKey: common.randomString(10),

            currentSearchType: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,
            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,
            tableButton: objectDefaultValue.TABLEBUTTON,

        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber', 'validateFloat'],),
        ...mapActions('handleData2', ['handleTypeImport', 'handleChangeType', 'formatData']),
        ...mapActions('giaDinhVanHoaVH', ['getPagingGiaDinhVanHoaVH', 'getDetailGiaDinhVanHoaVH', 'getCustomDetailGiaDinhVanHoaVH', 'checkExistGiaDinhVanHoaVH', 'createGiaDinhVanHoaVH', 'updateGiaDinhVanHoaVH', 'deleteGiaDinhVanHoaVH', 'restoreGiaDinhVanHoaVH', 'handleListGiaDinhVanHoaVH', 'setEnabledGiaDinhVanHoaVH', 'exportExcelGiaDinhVanHoaVH', 'getMapInfoGiaDinhVanHoaVH', 'importExcelGiaDinhVanHoaVH']),
        ...mapActions('dmKy', ['getBasicDMKy']),
        ...mapActions('phuongXa', ['getsPhuongXa']),
        async setup() {
            let header = 'Bạo lực gia đình'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_PHUONGXA = await this.getCategory_PhuongXa()
        },
        //#region TableNavigation
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },
        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.isShowModal.checkBoxConfirmModal = true
        },
        async navigateEnabledChange(id,  value) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                this.updateEnabled()
            }
        },
        async updateEnabled() {
            let model = {
                vanhoaGiadinhVanhoaId: this.cEnable_Item.id,
                enabled: this.cEnable_Item.enabled
            }
            await this.setEnabledGiaDinhVanHoaVH({ model: model }).then(async resp => {
                if (resp) {
                    this.isShowModal.checkBoxConfirmModal = false
                }
                else {
                    const itemIndex = this.items.findIndex(item => item.vanhoaGiadinhVanhoaId === this.cEnable_Item.id);
                    if (itemIndex !== -1) {
                        this.items[itemIndex].enabled = !this.items[itemIndex].enabled;

                    } else {
                        await this.getData()
                    }
                }

            });
        },
        async closeConfirmEnabledChange() {
            const itemIndex = this.items.findIndex(item => item.vanhoaGiadinhVanhoaId === this.cEnable_Item.vanhoaGiadinhVanhoaId);
            if (itemIndex !== -1) {
                this.items[itemIndex].enabled = !this.items[itemIndex].enabled;
            } else {
                await this.getData()
            }
            this.isShowModal.checkBoxConfirmModal = false
        },
        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },
        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async unSelectAllRows() {
            this.csList_Navigate.csList = []
            document.getElementById("checkboxAll").checked = false
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.vanhoaGiadinhVanhoaId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            this.modelSearch.enabled = await this.handleChangeType({ input: this.modelSearch.enabled, typeChange: objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN })
        },
        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()
            await this.unSelectAllRows()
            this.category_sKY = await this.getCategory_Ky(1)
            await this.getPagingGiaDinhVanHoaVH({ params: this.modelSearch, type: this.currentSearchType }).then(res => {
                // List data
                this.items = res.data
                this.totalRow = res.totalRow
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },
        //#endregion TableNavigation

        //#region CRUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.category_cKY = await this.getCategory_Ky()
            this.errors = giaDinhVanHoaVHModel.errors()
            this.loadingSubmit = false

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    vanhoaGiadinhVanhoaId: item.vanhoaGiadinhVanhoaId
                }
                await this.getDetailGiaDinhVanHoaVH({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = giaDinhVanHoaVHModel.newModel()
                        this.modelRec = resp
                        this.model = giaDinhVanHoaVHModel.parseModeltoFEModel(this.modelRec)

                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    vanhoaGiadinhVanhoaId: item.vanhoaGiadinhVanhoaId
                }
                await this.getDetailGiaDinhVanHoaVH({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = giaDinhVanHoaVHModel.newModel()
                        this.modelRec = resp

                    }
                });
                this.tempKey = common.randomString(10)
                this.isShowModal.detailModal = true
            }
            else {
                this.model = giaDinhVanHoaVHModel.newFEModel()
                this.isReadOnly = false
                // show popup
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistGiaDinhVanHoaVH({ params: params })
            return res.data
        },
        async validate(model) {
            let isvalid = true
            this.errors = giaDinhVanHoaVHModel.errors()
            if (!await this.validateRequired(model.idKy)) {
                this.errors.idKy = "Chọn kỳ"
                isvalid = false
            }
            if (!await this.validateRequired(model.phuongXaId)) {
                this.errors.phuongXaId = "Chọn phường xã"
                isvalid = false
            }
            if (!await this.validateNumber(model.tsHo)) {
                this.errors.tsHo = "Số hồ sơ phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoDk)) {
                this.errors.soHoDk = "Số hộ đăng ký phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeDk)) {
                this.errors.tyLeDk = "Tỷ lệ phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoDatGdvh)) {
                this.errors.soHoDatGdvh = "Số hộ đạt GĐVH phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeDatGdvh)) {
                this.errors.tyLeDatGdvh = "Tỷ lệ đạt GĐVH phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoKhongdatGdvh)) {
                this.errors.soHoKhongdatGdvh = "Số hộ không đạt GĐVH phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeKhongdatGdvh)) {
                this.errors.tyLeKhongdatGdvh = "Tỷ lệ không đạt GĐVH phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.tsHoGdCoTreEm)) {
                this.errors.tsHoGdCoTreEm = "Số hộ gia đình có trẻ em phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoGdCoTreEmDatGdvh)) {
                this.errors.soHoGdCoTreEmDatGdvh = "Số hộ gia đình có trẻ em đạt GĐVH phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeGdCoTreEmDatGdvh)) {
                this.errors.tyLeGdCoTreEmDatGdvh = "Tỷ lệ GĐ có trẻ em đạt GĐVH phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoGdCoTreEmKhongdatGdvh)) {
                this.errors.soHoGdCoTreEmKhongdatGdvh = "Số HGĐ có tre rem không đạt GĐVH phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeGdCoTreEmKhongdatGdvh)) {
                this.errors.tyLeGdCoTreEmKhongdatGdvh = "Tỷ lệ GĐ có trẻ em không đạt GĐVH phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.tsHoGdKhongTreEm)) {
                this.errors.tsHoGdKhongTreEm = "Số HGĐ không trẻ em phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoGdKhongTreEmDatGdvh)) {
                this.errors.soHoGdKhongTreEmDatGdvh = "Số hộ GĐ không trẻ em đạt GĐVH phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeGdKhongTreEmDatGdvh)) {
                this.errors.tyLeGdKhongTreEmDatGdvh = "Tỷ lệ GĐ không trẻ em đạt GĐVH phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoGdKhongTreEmKhongdatGdvh)) {
                this.errors.soHoGdKhongTreEmKhongdatGdvh = "Số HGĐ không trẻ em không đạt GĐVH phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeGdKhongTreEmKhongdatGdvh)) {
                this.errors.tyLeGdKhongTreEmKhongdatGdvh = "Tỷ lệ GĐ không đạt trẻ em không đạt GĐVH phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.tsHo3nam)) {
                this.errors.tsHo3nam = "Số hộ 3 năm phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateNumber(model.hoDat3nam)) {
                this.errors.hoDat3nam = "Số hộ đạt 3 năm phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyleHoDat3nam)) {
                this.errors.tyleHoDat3nam = "Tỷ lệ hộ đạt 3 năm phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoDuocKhenThuong3nam)) {
                this.errors.soHoDuocKhenThuong3nam = "Số hộ được khen thưởng 3 năm phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyleDuocKhenthuong3nam)) {
                this.errors.tyleDuocKhenthuong3nam = "Tỷ lệ được khen thưởng 3 năm phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.soHoDkNamsau)) {
                this.errors.soHoDkNamsau = "Số hộ đăng ký năm sau phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyleHoDkNamsau)) {
                this.errors.tyleHoDkNamsau = "Tỷ lệ hộ đăng ký năm sau phải là kiểu số thực"
                isvalid = false
            }
            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = giaDinhVanHoaVHModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.vanhoaGiadinhVanhoaId = FEmodel.vanhoaGiadinhVanhoaId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.vanhoaGiadinhVanhoaId = FEmodel.vanhoaGiadinhVanhoaId
                sendModel.quanHuyenId = config.QUANHUYEN_SITEID
                sendModel.phuongXaId = FEmodel.phuongXaId
                sendModel.idKy = FEmodel.idKy
                sendModel.tsHo = FEmodel.tsHo
                sendModel.soHoDk = FEmodel.soHoDk
                sendModel.tyLeDk = FEmodel.tyLeDk
                sendModel.soHoDatGdvh = FEmodel.soHoDatGdvh
                sendModel.tyLeDatGdvh = FEmodel.tyLeDatGdvh
                sendModel.soHoKhongdatGdvh = FEmodel.soHoKhongdatGdvh
                sendModel.tyLeKhongdatGdvh = FEmodel.tyLeKhongdatGdvh
                sendModel.tsHoGdCoTreEm = FEmodel.tsHoGdCoTreEm
                sendModel.soHoGdCoTreEmDatGdvh = FEmodel.soHoGdCoTreEmDatGdvh
                sendModel.tyLeGdCoTreEmDatGdvh = FEmodel.tyLeGdCoTreEmDatGdvh
                sendModel.soHoGdCoTreEmKhongdatGdvh = FEmodel.soHoGdCoTreEmKhongdatGdvh
                sendModel.tyLeGdCoTreEmKhongdatGdvh = FEmodel.tyLeGdCoTreEmKhongdatGdvh
                sendModel.tsHoGdKhongTreEm = FEmodel.tsHoGdKhongTreEm
                sendModel.soHoGdKhongTreEmDatGdvh = FEmodel.soHoGdKhongTreEmDatGdvh
                sendModel.tyLeGdKhongTreEmDatGdvh = FEmodel.tyLeGdKhongTreEmDatGdvh
                sendModel.soHoGdKhongTreEmKhongdatGdvh = FEmodel.soHoGdKhongTreEmKhongdatGdvh
                sendModel.tyLeGdKhongTreEmKhongdatGdvh = FEmodel.tyLeGdKhongTreEmKhongdatGdvh
                sendModel.tsHo3nam = FEmodel.tsHo3nam
                sendModel.hoDat3nam = FEmodel.hoDat3nam
                sendModel.tyleHoDat3nam = FEmodel.tyleHoDat3nam
                sendModel.soHoDuocKhenThuong3nam = FEmodel.soHoDuocKhenThuong3nam
                sendModel.tyleDuocKhenthuong3nam = FEmodel.tyleDuocKhenthuong3nam
                sendModel.soHoDkNamsau = FEmodel.soHoDkNamsau
                sendModel.tyleHoDkNamsau = FEmodel.tyleHoDkNamsau
                sendModel.ghiChu = FEmodel.ghiChu
                sendModel.enabled = FEmodel.enabled ? FEmodel.enabled : false
            }
            return sendModel
        },
        async handleSubmit() {
            if (this.code === this.navigateCode.DELETE) {
                this.csList_MapModel = {
                    title: this.$t('labels.confirmDelete'),
                    confirmLabelButton: this.$t('buttons.confirm'),
                    onClose: null,
                    onSubmit: this.onSubmit,
                    modalContent: "<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>",
                }
                this.isShowModal.confirmDialogModal = true
            }
            else {
                await this.onSubmit()
            }
        },
        async onSubmit() {
            this.loadingSubmit = true
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createGiaDinhVanHoaVH({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateGiaDinhVanHoaVH({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteGiaDinhVanHoaVH({ model: sendModel, type: this.currentSearchType })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteGiaDinhVanHoaVH({ model: sendModel, type: this.currentSearchType })
                    if (res) this.isShowModal.confirmDialogModal = false
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreGiaDinhVanHoaVH({ model: sendModel })
                    break
                default:
            }
            if (res) {
                this.isShowModal.CRUDModal = false
                await this.getData()
            }

            this.loadingSubmit = false
        },
        //#endregion CRUD
        //#region ListNavigation
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                let tempReConfirmMes = code == this.navigateCode.DELETE ?"<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>những dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>" : null
                this.csList_MapModel = {
                    isReConfirm: code == this.navigateCode.DELETE ? true : false,
                    reConfirmMes: tempReConfirmMes,
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: null,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.isShowModal.confirmDialogModal = true
            }
        },

        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            let res = null
            if (code == objectDefaultValue.NAVIGATECODE_VALUE.DELETE) {
                res = await this.handleListGiaDinhVanHoaVH(modelSend)
            }
            else {
                res = await this.handleListGiaDinhVanHoaVH(modelSend)
            }
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.isShowModal.confirmDialogModal = false
            }
        },
        //#endregion ListNavigation
        async getCategory_PhuongXa() {
            let params = {
                quanHuyenId: config.QUANHUYEN_SITEID
            }
            let res = await this.getsPhuongXa({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].phuongXaId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },
        async getCategory_Ky(filterNumber = 0) {
            let params = {
                tableName: tableValue.VH_GIADINHVANHOA,
                loaiKy: 'Y'
            }
            params.filter = filterNumber
            let res = await this.getBasicDMKy({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].idKy,
                            name: res[i].tenKy
                        }
                    )
                }
                return handleRes
            }
            return res
        },
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style>
</style>
